import * as actions from '../../../ActionsConst';

const switchWebsiteAction = (website) => ({
  website,
  type: actions.SWITCH_WEBSITE,
});

export const switchWebsite = (website) => (dispatch) => {
  dispatch(switchWebsiteAction(website));
};

export const highOrderSwitchWebsite = (func) => (website) => (dispatch) => {
  func(website);
  dispatch(switchWebsiteAction(website));
};
